export default {
  getPlaygrounds: (state) => {
    return state.playgrounds;
  },
  getActivities: (state) => {
    return state.activities;
  },
  getDate: (state) => {
    return state.date;
  },
  getBlocksByDate: (state) => {
    return state.blocksByDate;
  },
  getOperations: (state) => {
    return state.operations;
  },
}
